import React from 'react';
import {createPortal} from 'react-dom';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import {useTranslation} from 'react-i18next';
import {FLOATING_SHADOW} from '../../../../common/newVariablePicker/shared/floatingShadow';
import {getNodeColor, NodeCategoryConfig} from '../../config/nodeCategories';
import {NODE_COPY} from './nodeCopy';

interface NodeDragPreviewProps {
    node: NodeCategoryConfig;
    previewRef: React.RefObject<HTMLDivElement>;
}

const NodeDragPreview: React.FC<NodeDragPreviewProps> = ({node, previewRef}) => {
    const {t} = useTranslation();
    const copy = NODE_COPY[node.type];

    return createPortal(
        <Paper
            ref={previewRef}
            variant={'outlined'}
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                zIndex: theme => theme.zIndex.modal + 2,
                pointerEvents: 'none',
                opacity: 0.92,
                borderRadius: 2,
                p: 1.5,
                maxWidth: 260,
                boxShadow: FLOATING_SHADOW,
            }}
        >
            <Stack direction={'row'} alignItems={'center'} gap={1}>
                <Box sx={{color: getNodeColor(node.type), display: 'flex'}}>
                    {node.icon}
                </Box>
                <Box sx={{minWidth: 0}}>
                    <Typography variant={'subtitle2'} noWrap>
                        {t(node.label)}
                    </Typography>
                    {!!copy && (
                        <Typography variant={'body2'} color={'text.secondary'}>
                            {t(copy.summary)}
                        </Typography>
                    )}
                </Box>
            </Stack>
        </Paper>,
        document.body,
    );
};

export default NodeDragPreview;
